// @flow
import * as React from 'react';
import {
    lightBlue,
    amber,
    orange,
    green,
    grey,
    lightGreen,
    red
} from '@material-ui/core/colors';
import {
    Schedule,
    Timelapse,
    FindInPage,
    CheckCircle,
    RemoveCircle,
    Cancel,
    MonetizationOn,
    Warning,
    Storage,
    Autorenew
} from '@material-ui/icons';
import { SketchOrderStatus } from './sketchOrderStatuses';
import type { SketchOrderStatusType } from './sketchOrderStatuses';

type SketchOrderStatusDisplayConfig = {
    displayName: string,
    color?: string,
    icon?: React.Node,
}

const getDisplayConfig = (sketchOrderStatus: SketchOrderStatusType): SketchOrderStatusDisplayConfig => {
    switch(sketchOrderStatus) {
        case SketchOrderStatus.Pending:
            return {
                color: lightBlue[500],
                icon: <Schedule />,
                displayName: 'Pending',
            }
        case SketchOrderStatus.RevisionRequested:
            return {
                color: lightBlue[500],
                icon: <Autorenew />,
                displayName: 'Revision Requested',
            }
        case SketchOrderStatus.Queued:
            return {
                color: lightBlue[500],
                icon: <Storage />,
                displayName: 'Queued',
            }
        case SketchOrderStatus.InProgress:
            return {
                color: amber[500],
                icon: <Timelapse />,
                displayName: 'In Progress',
            }
        case SketchOrderStatus.PendingReview:
            return {
                color: lightGreen[500],
                icon: <FindInPage />,
                displayName: 'Pending Review',
            }
        case SketchOrderStatus.PendingRejection:
            return {
                color: orange[500],
                icon: <Cancel />,
                displayName: 'Pending Rejection',
            }
        case SketchOrderStatus.Complete:
            return {
                color: green[600],
                icon: <CheckCircle />,
                displayName: 'Complete',
            }
        case SketchOrderStatus.Billed:
            return {
                color: green[600],
                icon: <MonetizationOn />,
                displayName: 'Billed',
            }
        case SketchOrderStatus.Incomplete:
            return {
                color: grey[500],
                icon: <RemoveCircle />,
                displayName: 'Incomplete',
            }
        case SketchOrderStatus.Cancelled:
            return {
                color: grey[500],
                icon: <Cancel />,
                displayName: 'Cancelled',
            }
        case SketchOrderStatus.Exception:
            return {
                color: red[500],
                icon: <Warning />,
                displayName: 'Needs Attention',
            }
        case SketchOrderStatus.BillingFailed:
            return {
                color: red[500],
                icon: <Warning />,
                displayName: 'Billing Failed',
            }
        case SketchOrderStatus.InReview:
            return {
                color: lightBlue[500],
                icon: <Timelapse />,
                displayName: 'In Review',
            }
        case SketchOrderStatus.PendingGroupBilling:
            return {
                color: green[600],
                icon: <MonetizationOn />,
                displayName: 'Pending Group Billing'
            }
        default: {
            return {
                displayName: sketchOrderStatus,
            }
        }
    }
};

export default getDisplayConfig;
